import {
  MDBBtn,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getExistingUserLocations, getGlobalLocationList, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import DeleteLocationFilter from "../../views/popups/users/DeleteLocationFilter";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import { isFiveNineAccount } from "../../views/Login";
import CommonMoreOptions from "../../apiclients/CommonMoreOptions";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../editviews/user/ImportUser";
export default function ULocations(props) {
  /************************************************************************/
  const [locations, setLocations] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const [isloading, setIsloading] = useState(true);
  const [locationList, setLocationList] = useState([]);
  const [LocationSelected, setLocationSelected] = useState("");
  const [LocationSelectedIds, setLocationSelectedIds] = useState([]);
  const [newLocationSelectedIds, setNewLocationSelectedIds] = useState([]);
  const [existLocationSelectIds, setexistLocationSelectIds] = useState([]);
  const [existNewLocationSelectIds, setexistNewLocationSelectIds] = useState([]);
  const [filterLocationList, setfilterLocationList] = useState([]);
  const [displayFilterLocations, setdisplayFilterLocations] = useState([]);
  const [displayNewFilterLocations, setdisplayNewFilterLocations] = useState([]);
  const [reRender, setreRender] = useState(true);
  const [searchMainValue, setsearchMainValue] = useState("");
  const [searchEditValue, setsearchEditValue] = useState("");
  const [deleteFilter, setdeleteFilter] = useState(false);
  const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
  const [allLocation, setallLocation] = useState(false);
  const [allNewLocation, setallNewLocation] = useState(false);
  const [isloading, setIsloading] = useState(false)
  const deleteLocRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  function handleClick() {
    deleteLocRef.current.click();
  }
  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
  const [allChecked, setallChecked] = useState(false);
  const [disableMulti, setdisableMulti] = useState(true);
  const [locidList, setlocidList] = useState([]);
  const [locNames, setLocNames] = useState([]);
  const isFiveNineAccounts = isFiveNineAccount();
const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [DropDownitem, setDropDownitem] = useState([
    {
      label: "Caller-ID",
      key: "caller-id",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Location",
      key: "location",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Billing Group",
      key: "billing-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Seat Plan",
      key: "seat-plan",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Permission Role",
      key: "permission-role",
      show: !isFiveNineAccounts,
    },
    {
      label: "Add to a Group",
      key: "add-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Resend Welcome Email",
      key: "resend-email",
    },
  ]);


  /*************************************************************************/
  function showThisInf(tdata) {
    navigate("/locationsusers", {
      state: tdata.locDetails,
    });
  }

  const handleAllChecked = (isChecked) => {
    if (isChecked) {
      setallChecked(true);
      const locIds = [];
      const LocNames = [];
      filteredRows.forEach(({ location_id, name }) => {
        locIds.push(location_id + "");
        LocNames.push(name);
      });
      setlocidList(locIds);
      setLocNames(LocNames);
      setdisableMulti(false);


    } else {
      setallChecked(false);
      setlocidList([]);
      setLocNames([]);
      setdisableMulti(true);
    }
  }

  function handleCheckedRow(e, selectrow) {
    // e.preventDefault();
    let locs = selectrow.location_id + "";
    let locname = selectrow.name;
    let updatedLocs = [];
    let updatedLocNames = [];

    if (e.target.checked) {
      updatedLocs = [...locidList, locs];
      updatedLocNames = [...locNames, locname];


    } else {
      updatedLocs = locidList.filter((tmdata) => tmdata !== locs);
      updatedLocNames = locNames.filter((tmdata) => tmdata !== locname);

    }

    const allSelected = filteredRows.length > 0 ? filteredRows.every(row => updatedLocs.includes(row.location_id + "")) : false;
    if (allSelected) {
      setallChecked(true);
    } else {
      setallChecked(false);
    }
    if (updatedLocs.length > 0) {
      setdisableMulti(false);
    } else {
      setdisableMulti(true);
    }
    setlocidList(updatedLocs);
    setLocNames(updatedLocNames);
  }




useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)

  const basicData = {
    columns: [
      {
        label: (<>
          <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
        </>), field: "checkBoxValue", sort: false
      },
      { label: 'Name', field: 'name' },
      { label: 'Address', field: 'Address' },
      { label: 'Users', field: 'user' },
    ],
    rows: locationList,
  };
  /********************************Fetching Display Data Starts Here!************************************************* */

  useEffect(() => {
    const fetchExistingLocations = async () => {
      try {
        sessionStorage.setItem("current_link", "loclanding");
        console.log("[fetchExistingLocations] ");
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        //let groupid = 1;
        let serverResponse = await getExistingUserLocations(siteid);

        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error('Network response was not ok');
        } else {
          let responseData = await serverResponse.json()
          let apiData = responseData.locations;
          console.log("Locations List:::: " + JSON.stringify(apiData));
          let data = [];
          apiData.forEach(element => {
            var json = {};
            json.locDetails = element;
            json.checkBoxValue = (<>
              <MDBCheckbox checked={locidList.includes(element.location_id + "")} onClick={(e) => handleCheckedRow(e, element)} />
            </>);
            json.default_loc = element.default_loc;
            // json.name = <div className="d-flex align-items-center">{element.location_name}
            //   {element.default_loc && (
            //     <>
            //       <div className="px-2 ms-2 border border-1 rounded-pill border-success">
            //         <span className="small text-success">Default</span>
            //       </div>
            //     </>
            //   )}
            json.name = element.location_name
            json.Address = element.address;
            json.user = element.users ?? '-';
            json.location_id = element.location_id;
            data.push(json);
          });
          setLocationList(data);
          setFilteredRows(data)
          setDataLoaded(true)
        }
      } catch (e) {
        console.log("[BlfUsers.js][fetchExistingUsers] : " + e);
      }
    }
    // fetchExistingLocations();

  if (props.isActive) {
    fetchExistingLocations();
  }
  }, [props.isActive]);

  useEffect(() => {
    setFilteredRows(filteredRows.map(Locns => ({
      ...Locns, checkBoxValue: (<>
        <MDBCheckbox checked={locidList.includes(Locns.location_id + "")} onClick={(e) => handleCheckedRow(e, Locns)} />
      </>)
    })))
  }, [locidList]);

  useEffect(() => {
    if (reRender) {
      // const userLocationFilter = sessionStorage.getItem("userLocationFilter") ?
      //   JSON.parse(sessionStorage.getItem("userLocationFilter")) :
      //   [];
      // const glocationChanged = sessionStorage.getItem("global_location_changed");

      // if (userLocationFilter && userLocationFilter.length > 0 && !glocationChanged) {
      //   setTheStateValues(userLocationFilter);
      // } else {
      //   sessionStorage.removeItem('global_location_changed');
      getUserLocationFilter();
      // }
      setreRender(false);
    }
  }, [reRender]);


  async function getUserLocationFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=3`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      // debugger;
      console.log(" getUserLocationFilter Global user Locations filter ::::::::: : " + JSON.stringify(rawData));
      // alert("JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ");
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      let userLocationsFilter = rawData?.result ?? [];
      // userLocationsFilter = userLocationsFilter.filter((loc) => parseInt(loc.entity_id) !== -1);
      setTheStateValues(userLocationsFilter);
      // sessionStorage.setItem("userLocationFilter", JSON.stringify(userLocationsFilter));

    } catch (error) {

    }

  }

  function setTheStateValues(userLocationsFilter) {
    let LocationSelected = userLocationsFilter.filter(userLocation => userLocation.selected).map(userLocation => userLocation.entity_name).join(', ');
    const LocationSelectedids = userLocationsFilter.some(location => location.entity_id === -1 && location.selected)
      ? userLocationsFilter.map(location => location.entity_id)
      : userLocationsFilter.filter(location => location.selected).map(location => location.entity_id);
    const index = LocationSelectedids.findIndex(id => id === -1);
    if (index !== -1) {
      LocationSelectedids.splice(index, 1);
      LocationSelected = "";
      setNewLocationSelectedIds(LocationSelectedids);
      setexistNewLocationSelectIds(LocationSelectedids);
      // setallLocation(true);
      setallNewLocation(true);
    }

    const newuserLocationsFilter = userLocationsFilter.filter((loc) => parseInt(loc.entity_id) !== -1);
    setfilterLocationList(newuserLocationsFilter);
    setdisplayFilterLocations(newuserLocationsFilter);
    setdisplayNewFilterLocations(newuserLocationsFilter);
    if (LocationSelected && LocationSelected !== "") {
      setLocationSelected(`${t("userLocations")} : ${LocationSelected}`);
      setLocationSelectedIds(LocationSelectedids);
      setexistLocationSelectIds(LocationSelectedids);
    }

  }

  function cancelfilterChanges(flag) {
    if (flag === 1) {
      setLocationSelectedIds(existLocationSelectIds);
      if (existLocationSelectIds.length === filterLocationList.length || existLocationSelectIds.length === displayFilterLocations.length) {
        setallLocation(true);
      } else {
        setallLocation(false);
      }
    } else {
      setNewLocationSelectedIds(existNewLocationSelectIds);
      if (existNewLocationSelectIds.length === filterLocationList.length || existNewLocationSelectIds.length === displayFilterLocations.length) {
        setallNewLocation(true);
      } else {
        setallNewLocation(false);
      }
    }
  }

  const handleFilterCheckboxChange = (value) => {
    const updatedValues = [...LocationSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterLocations.length) {
      setallLocation(false);
    } else {
      const tempArray = displayFilterLocations.map(loc => loc.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallLocation(false);
          break;
        }
      }
      setallLocation(true);
    }
    setLocationSelectedIds(updatedValues);
  };

  const handleNewFilterCheckboxChange = (value) => {
    const updatedValues = [...newLocationSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }

    if (updatedValues.length !== displayNewFilterLocations.length) {
      setallNewLocation(false);
    } else {
      const tempArray = displayNewFilterLocations.map(loc => loc.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallNewLocation(false);
          break;
        }
      }
      setallNewLocation(true);
    }

    setNewLocationSelectedIds(updatedValues);
  };

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  const handleSubmit = async (event, selectValue) => {
    event.preventDefault();
    let filteredValue = [...selectValue];
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    if (selectValue.length === filterLocationList.length) {
      filteredValue = [-1];

    }
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: filteredValue,
      filter_type: 1,
      filter_key: 3,
      module_type: 3,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify Location user filter value  :::: " + JSON.stringify(update));
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit Location user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified Location user data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
      // sessionStorage.removeItem('userLocationFilter');
      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sloc" },
      });
      window.location.reload();
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  function handleSearch(e, flag) {
    const value = e.target.value;
    if (flag === 1) {
      setsearchMainValue(value);
      setdisplayFilterLocations(customSearch(filterLocationList, value, ['entity_name']))
    } else {
      setsearchEditValue(value);
      setdisplayNewFilterLocations(customSearch(filterLocationList, value, ['entity_name']))   }
  }

  function setDefaultValue(e) {
    e.preventDefault();
    if (LocationSelected) {
      setNewLocationSelectedIds([]);
    }
  }

  function handleAllLocation(e) {
    // e.preventDefault();
    setallLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterLocations.map(loc => loc.entity_id);
      setLocationSelectedIds(locId);
    } else {
      setLocationSelectedIds([]);
    }

  }
  function handleNewAllLocation(e) {
    // e.preventDefault();
    setallNewLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterLocations.map(loc => loc.entity_id);
      setNewLocationSelectedIds(locId);
    } else {
      setNewLocationSelectedIds([]);
    }

  }

  const removeUserLocFilter = (value) =>{
    removeThisFilter(3);

  }
  const removeallfilters = (value) =>{
    removeThisFilter(-1);

  }

  async function removeThisFilter(filterKey) {
    // e.preventDefault();
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 3,
    }

    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sloc" },

      });
      window.location.reload();


    } else {
      localStorage.setItem("s_message", deleteMsg.message);
      // sessionStorage.removeItem('userLocationFilter');
      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sloc" },
      });
      window.location.reload();

    }
  }




  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(locationList, searchValue, UIConstant.USER_LOCATION);

    setFilteredRows(filteredUsers);
  };


  /********************************************************************************* */
  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      <div>
        <div className="d-flex align-items-center justify-content-between actionbar  ">
          <CommonMoreOptions
            DropDownitem={DropDownitem}
            disableMulti={disableMulti}
            agentList={locidList}
            userLoc={true}
            moduleType={3}
            moduleid="common-more-options-portal-userLoc"
            showWarning={true}
            onImpExpRedirect={() => setShowImpExpRedirect(true)}
            onImpExpWarning={(msg) => { setWarningMessage(msg); warningToggle(); }}
          />
        </div>
        <div className="position-absolute left__341px d-flex">
          <div className="d-flex">
            <div className="mx-3 popconfirmFilter">
              {LocationSelected && (
                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                  <MDBChip className="m-0" onClick={(e) => setDefaultValue(e)}

                  >
                    <div className="filterElliipse">
                      {LocationSelected}
                    </div>
                    <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); removeUserLocFilter() }} />
                  </MDBChip>
                </>}>
                  <MDBPopconfirmMessage className="p-2">
                    <p className='mb-2 fw-600'>
                      {t("location")}
                    </p>

                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e, 1)} />
                    </div>
                  </div>
                  <div className="filter-border py-2"></div>
                  <div className="mt-3">
                    <MDBCheckbox checked={allLocation} onChange={(e) => handleAllLocation(e)} label="Select All" />
                  </div>
                  <div className="filtersScroll">
                    {displayFilterLocations && displayFilterLocations.map((Location) => (
                      <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={LocationSelectedIds.includes(Location.entity_id)}
                        onChange={() => handleFilterCheckboxChange(Location.entity_id)}
                      />

                    ))}
                    <div className="filter-border"></div>
                  </div>
                  <div className="d-flex float-end mt-3">
                    {(LocationSelectedIds.length > 0 && !isArraysEqual(LocationSelectedIds, existLocationSelectIds)) && (
                      <>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                          handleSubmit(e, LocationSelectedIds);
                        }}> Apply</MDBBtn>
                      </>
                    )}

                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            )}
          </div>
          {!LocationSelected && (
            <div className=" ms-2">
              <MDBPopconfirm placement='bottom-start' onClick={(e) => { setDefaultValue(e); setIsFilterOpen(true); }} onClose={() => setIsFilterOpen(false)}  className="shadow-6" btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
                <MDBPopconfirmMessage className="p-2">
                  <p className='mb-2 fw-600'>
                    {t("location")}
                  </p>

                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <MDBInput autoFocus={isFilterOpen} placeholder="search" value={searchEditValue} onChange={(e) => handleSearch(e, 2)} />
                    </div>
                  </div>
                  <div className="filter-border py-2"></div>
                  <div className="mt-3">
                    <MDBCheckbox checked={allNewLocation} onChange={(e) => handleNewAllLocation(e)} label="Select All" />
                  </div>
                  <div className="filtersScroll">
                    {displayNewFilterLocations && displayNewFilterLocations.map((Location) => (
                      <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={newLocationSelectedIds.includes(Location.entity_id)}
                        onChange={() => handleNewFilterCheckboxChange(Location.entity_id)}
                      />
                    ))}
                  </div>
                  <div className="filter-border"></div>
                  <div className="d-flex float-end mt-3">
                    {(newLocationSelectedIds.length !== 0 && newLocationSelectedIds.length !== filterLocationList.length) && (
                      <>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(2)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                          handleSubmit(e, newLocationSelectedIds);
                        }}> Apply</MDBBtn>
                      </>
                    )}

                    </div>
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>
              </div>
            )}
            {LocationSelected && (
              <MDBBtn className="mx-2" onClick={removeallfilters}>Clear</MDBBtn>
            )}
          </div>
        </div>
      </div>

      <div className="w-100 actionbar mob-abs"> </div>
      <div className='mb-2 mt-3 position-relative w-auto'>
        <MDBInput label="Search" ref={searchRef} value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
      </div>
      <div className="w-100 usersDataTable">
        <MDBDatatable className="datatableSelect actioncolumn"
          onRowClick={(event) => {
            showThisInf(event);
          }}
           key={searchValue}
          fixedHeader
          entries={50}
          maxHeight="63vh"
          sortField="Name"
          sortOrder="asc"
          searchInputProps={[]}
          data={{
            ...basicData,
            rows: filteredRows, // Use filtered rows here
          }}
          responsive
          hover
        />
      </div>
      {deleteFilter && (
        <PopupLoaderNew
          title={"Delete Location Filter"}
          content={<DeleteLocationFilter
            locationflag={1}
            onClose={deleteFilterToggle}
            ref={deleteLocRef}
            setIsloading={setisLoading}
          />}
          onShow={setdeleteFilter}
          onClose={deleteFilterToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      <div id="common-more-options-portal-userLoc"></div>
      {showWarning && (
        <ImportProgressWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={warningToggle}
          message={warningMessage}
        />
      )}
      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}
      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
              {/* <MDBBtn className='btn-close' color='none' onClick={importuserToggle}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
